module.exports = __webpack_public_path__ + "static/parallax-sword-8b1c6f4f038599064ac041b0d8d57139.jpg";